/* Pretty Muse — accessible Size Chart modal */
(() => {
  if (window.__prettyMuseSizeChartInitialized) return;
  window.__prettyMuseSizeChartInitialized = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-chart-open]');
    if (openButton) {
      const dialogId = openButton.getAttribute('data-size-chart-open');
      const dialog = document.getElementById(dialogId);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        const closeButton = dialog.querySelector('[data-size-chart-close]');
        if (closeButton) closeButton.focus();
      }
      return;
    }

    const closeButton = event.target.closest('[data-size-chart-close]');
    if (closeButton) {
      const dialog = closeButton.closest('[data-size-chart-dialog]');
      if (dialog) dialog.close();
      return;
    }

    const dialog = event.target.closest('[data-size-chart-dialog]');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });
})();
